export const optionsJob = [
    {id:1,title:'1 room'},
    {id:2,title:'2 room'},
    {id:3,title:'More'},
  ]

export const filterAreas = [
{ title:'House', symbol:'one'},
{ title:'Townhouse', symbol:'two'},
{ title:'Apartment', symbol:'three'},
//{ title:'Room'},
//{ title:'Parking'},
]
